import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Scale, Zap } from "lucide-react";

const items = [
  {
    icon: Scale,
    title: "Independent rankings",
    text: "We rank operators on offer value, redemption speed, game depth and availability — not on who pays the most.",
  },
  {
    icon: Zap,
    title: "Hands-on testing",
    text: "Every site is signed up to, funded and cashed out from, so our notes reflect the real experience rather than the marketing.",
  },
  {
    icon: ShieldCheck,
    title: "Responsible play first",
    text: "We only list licensed operators and put the 18+ (21+ in some markets) message front and centre on every page.",
  },
];

const AboutPage = () => {
  return (
    <div className="mx-auto max-w-3xl px-5 py-16">
      <h1 className="cp-fade-up text-3xl font-bold sm:text-4xl" style={{ color: "#ffffff" }}>
        About CasinoPicks
      </h1>
      <p
        className="cp-fade-up mt-4 text-sm leading-relaxed sm:text-base"
        style={{ color: "var(--cp-text)", animationDelay: "60ms" }}
      >
        CasinoPicks is an independent guide to sweepstakes casinos and sportsbooks.
        We test operators the way a real player would — funding accounts, placing
        bets, playing games and withdrawing — then rank them on what actually
        matters during a session.
      </p>

      <div className="mt-10 grid gap-4 sm:grid-cols-3">
        {items.map((it, i) => {
          const Icon = it.icon;
          return (
            <div
              key={it.title}
              className="cp-fade-up rounded-2xl border p-5"
              style={{
                borderColor: "var(--cp-border)",
                background: "var(--cp-card)",
                animationDelay: `${120 + i * 80}ms`,
              }}
            >
              <div
                className="flex h-10 w-10 items-center justify-center rounded-lg"
                style={{ background: "rgba(34,224,107,0.12)", color: "var(--cp-green)" }}
              >
                <Icon size={20} />
              </div>
              <h3 className="mt-4 text-base font-semibold" style={{ color: "#ffffff" }}>
                {it.title}
              </h3>
              <p className="mt-2 text-sm leading-snug" style={{ color: "var(--cp-muted)" }}>
                {it.text}
              </p>
            </div>
          );
        })}
      </div>

      <div
        className="mt-10 rounded-lg px-5 py-4 text-sm"
        style={{ background: "rgba(255,255,255,0.02)", borderLeft: "3px solid var(--cp-green)" }}
      >
        <span className="font-semibold" style={{ color: "#ffffff" }}>
          Play for fun, never for income.
        </span>{" "}
        <span style={{ color: "var(--cp-muted)" }}>
          You must be 18+ (21+ at some operators). Sweepstakes casinos are not real
          money gambling and Gold Coins have no monetary value.
        </span>
      </div>

      <Link
        to="/"
        className="mt-8 inline-block text-sm font-semibold"
        style={{ color: "var(--cp-green)" }}
      >
        ← Back to Top Picks
      </Link>
    </div>
  );
};

export default AboutPage;
